import { render, staticRenderFns } from "./add-wrapper.vue?vue&type=template&id=3ca111c3&scoped=true"
import script from "./add-wrapper.vue?vue&type=script&lang=js"
export * from "./add-wrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ca111c3",
  null
  
)

export default component.exports